import React from "react";
import MedicalServicesPage from "../Components/MedicalServices/MedicalServicesPage";

const MedicalServices = () => {
  return <MedicalServicesPage />;
};

export default MedicalServices;